import React from 'react';
import styles from './Grid.module.sass';

export default class Grid extends React.Component {

  render() {
    return (
      <div className={styles.Grid}>
        {this.props.children}
      </div>
    );
  }

}